module.exports = __webpack_public_path__ + "bd46bbe594e98d6232d7d3b6c4ea8605.pdf";